{
  "greeting": {
    "salam": "Selamün aleyküm",
    "salamWithName": "Selamün aleyküm, {{name}}"
  },
  "dock": {
    "saved": "Kaydedildi",
    "savedVerses": "Kaydedilen ayetler",
    "tasks": "Görevler",
    "notes": "Notlar"
  },
  "actions": {
    "save": "Kaydet",
    "cancel": "İptal",
    "close": "Kapat",
    "delete": "Sil",
    "rename": "Yeniden adlandır",
    "dismiss": "Kapat",
    "loading": "Yükleniyor…",
    "reload": "Yeniden yükle",
    "retry": "Yeniden dene",
    "expand": "Genişlet",
    "collapse": "Daralt"
  },
  "nav": {
    "appNavigation_aria": "Uygulama gezinmesi"
  },
  "tabs": {
    "home": "Ana Sayfa",
    "tasks": "Görevler",
    "notes": "Notlar",
    "more": "Daha Fazla"
  },
  "more": {
    "daily": "Günlük",
    "account": "Hesap",
    "savedVerses": "Kaydedilen ayetler",
    "qibla": "Kıble",
    "prayerTimes": "Namaz Vakitleri ve Hatırlatıcılar",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "Rhemn hesabınız üzerinden yönetilir",
    "upgrade": "Yükselt",
    "privacyPolicy": "Gizlilik Politikası",
    "version": "Rhemn · v{{version}}",
    "back_aria": "Geri",
    "deleteAccount": "Hesabı sil"
  },
  "reflection": {
    "dismiss_aria": "Tefekkürü kapat"
  },
  "app": {
    "loading_aria": "Rhemn yükleniyor",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "Rhemn Pro aboneliğinizi web üzerinden yönetin. Abone olduğunuz hesapla giriş yaptığınızda Pro burada otomatik olarak açılır."
  },
  "header": {
    "qiblaDirection_aria": "Kıble yönü",
    "prayerTimes_aria": "Namaz vakitleri",
    "prayerTimesTitle": "Namaz Vakitleri",
    "method": "Yöntem",
    "methodHelp": "Yöntem hesaplanan vakitleri etkiler"
  },
  "search": {
    "search_aria": "Ara",
    "searchLabel": "Ara",
    "searchWeb_placeholder": "Web'de ara"
  },
  "focus": {
    "input_placeholder": "Bugün en önemli olan ne?",
    "example_worship": "Namazı acele etmeden, huzurla kılmak",
    "example_kindness": "Sadece dinlemek için annemi aramak",
    "example_reflect": "Günün ayetiyle niyetin üzerine tefekkür etmek",
    "saveIntention_aria": "Niyeti kaydet",
    "celebration": "🤲 Maşallah"
  },
  "profile": {
    "profileFallback": "Profil",
    "profileAndAccount_aria": "Profil ve hesap",
    "profileDialog_aria": "Profil",
    "editName_aria": "Adınızı düzenleyin",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "Aboneliği yönet",
    "manageSubscription_aria": "Rehmn Pro aboneliğinizi yönetin",
    "anonymousAnalytics": "Anonim analiz",
    "anonymousAnalyticsNote": "Yalnızca toplu — asla size bağlanmaz",
    "shareAnalytics_aria": "Anonim kullanım analizlerini paylaş",
    "signOut": "Çıkış Yap",
    "signingOut": "Çıkış yapılıyor…",
    "signOut_aria": "Rehmn'den çıkış yap",
    "restorePurchases": "Satın alımları geri yükle",
    "restorePurchases_aria": "Önceki satın alımları geri yükle"
  },
  "background": {
    "loading": "Arka plan yükleniyor...",
    "fallbackNotice": "Yedek görsel kullanılıyor (Unsplash API kullanılamıyor)",
    "noImage": "Arka plan görseli yok",
    "error": "Hata: {{message}}",
    "photoByOnUnsplash": "Fotoğraf: <photographer>{{name}}</photographer>, <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "Bir şeyler ters gitti",
    "fallbackMessage": "Beklenmeyen bir hata oluştu."
  },
  "theme": {
    "switchToLight_title": "Açık moda geç",
    "switchToDark_title": "Koyu moda geç"
  },
  "upgradeCta": {
    "upgradeToPro": "Pro'ya yükselt",
    "restorePurchases": "Satın alımları geri yükle",
    "restoring": "Geri yükleniyor…",
    "restoreEmpty": "Satın alım bulunamadı.",
    "pricePerMonth": "{{price}} / ay",
    "pricePerYear": "{{price}} / yıl",
    "purchasePending": "Onay bekleniyor. Satın alma onaylandığında Pro otomatik olarak etkinleşir.",
    "storeUnavailable": "App Store'a şu anda ulaşılamıyor. Birazdan yeniden deneyin.",
    "purchaseFailed": "Satın alma tamamlanamadı. Birazdan yeniden deneyin."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · İlk yıl %25 indirim",
    "title": "Namazlarının arasındaki saatler için.",
    "body": "Yazıya dökülen, özetlenen ve göreve dönüşen sesli notlar. Namaz vakitlerine göre kurulmuş bir gün planlayıcı. Yapay zekâ destekli notlar.",
    "price": "$29.99",
    "period": "ilk yılın için",
    "priceIos": "İlk yıl %25 indirim",
    "terms": "Ardından yılda $39.99. {{code}} kodu senin için uygulandı.",
    "termsIos": "Normal yıllık fiyattan yenilenir. App Store'da {{code}} kodunu kullan.",
    "free": "Namaz vakitleri, kıble, günün ayeti ve görevler ücretsiz kalır.",
    "cta": "Pro'ya yükselt",
    "dismiss": "Şimdi değil"
  },
  "planChooser": {
    "monthly": "Aylık",
    "yearly": "Yıllık",
    "yearlyValue": "Dört ay bizden.",
    "freeNote": "Namaz vakitleri, kıble, günün ayeti ve görevler ücretsiz. Rhemn Pro şunları ekler:",
    "includes_planner": "Beş vakit namaz etrafında kurulan bir gün planı ve “Günümü planla”",
    "includes_insights": "Quran Insights — herhangi bir ayet hakkında soru sorun, bağlamını okuyun",
    "includes_reflections": "Belirlediğiniz niyete göre yazılan günün ayeti tefekkürleri",
    "includes_notes": "Notlar ve sesli notlar; yapay zekâ ile özet ve düzenleme",
    "includes_extras": "Kaydedilen ayetler, ayet kartları, seriler ve 5 günlük hava tahmini",
    "renewsMonthly": "İptal edilene kadar her ay yenilenir",
    "renewsYearly": "İptal edilene kadar her 12 ayda bir yenilenir",
    "continue": "Devam et",
    "renewalTerms": "Ödeme, satın alma onaylandığında Apple Kimliğinizden tahsil edilir. Dönem bitiminden en az 24 saat önce otomatik yenileme kapatılmazsa abonelik otomatik olarak yenilenir. Apple Kimliği ayarlarından dilediğiniz zaman yönetebilir veya iptal edebilirsiniz.",
    "retry": "Tekrar dene"
  },
  "streak": {
    "badge_aria": "Günlük seri — {{count}} gün",
    "title": "Günlük seri",
    "daysWithCount": "{{count}} günlük seri",
    "start": "Bugün başlayın — ayetle bir an geçirin veya bir namazı işaretleyin.",
    "prayedToday": "Bugün namaz kıldım",
    "readVerse": "Bugünün ayetini okudum",
    "autoHint": "Ayetle bir an geçirdiğinizde kendiliğinden işaretlenir.",
    "milestoneTitle": "Niyetle {{count}} gün",
    "milestoneBody": "Elhamdülillah. Bu güzel anı paylaşın — sevdiğiniz biri de başlayabilir.",
    "share": "Paylaş",
    "dismiss": "Şimdi değil",
    "cardLabel": "niyetle geçen gün",
    "shareCaption": "Niyetle başlayan {{count}} gün — rhemn.com",
    "imageSaved": "Görsel kaydedildi.",
    "couldNotCreateImage": "Görsel oluşturulamadı. Lütfen tekrar deneyin."
  },
  "qibla": {
    "compassIcon_aria": "Pusula simgesi",
    "title": "Kıble Yönü",
    "locationUnavailable": "Konum kullanılamıyor",
    "locating": "Konum belirleniyor…",
    "compass_aria": "Kıble pusulası",
    "directionN": "K",
    "directionE": "D",
    "directionS": "G",
    "directionW": "B",
    "facingQibla": "Kıbleye dönüksünüz",
    "enableLiveCompass": "Canlı Pusulayı Etkinleştir",
    "enableLiveCompassNote": "Hareket sensörünü kullanır, böylece döndükçe ok takip eder — konumu değil",
    "directionToMecca": "Mekke yönü",
    "enableLocation": "Yönü hesaplamak için konum erişimini etkinleştirin",
    "hintLive": "Ok, cihazınızın yönünü gerçek zamanlı olarak izler",
    "hintStatic": "Kuzeye göre yön — doğru yön için bir pusulayla kullanın",
    "live": "Canlı",
    "footerVerse": "\"Artık yüzünü Mescid-i Haram semtine çevir\" – Kuran 2:144"
  },
  "legal": {
    "links_aria": "Yasal",
    "termsOfUse": "Kullanım Koşulları",
    "privacyPolicy": "Gizlilik Politikası"
  },
  "auth": {
    "signInForPro": "Önce giriş yapın — Pro'nuz her yerde sizinle."
  },
  "integrations": {
    "row": {
      "label": "Takvimler ve görevler",
      "caption": "Bağlı",
      "subNone": "Bağlı değil",
      "subFree": "Google Takvim, Google Görevler ve daha fazlası",
      "subAttention": "{{provider}} dikkat gerektiriyor",
      "subPaused": "Senkronizasyon duraklatıldı"
    },
    "list": {
      "title": "Takvimler ve görevler",
      "subtitle": "Toplantılarını ve yapılacaklarını gününe taşı.",
      "footnote": "Rhemn yalnızca gerekli olanı okur ve etkinliklerini asla saklamaz.",
      "privacy": "Gizlilik Politikası",
      "connect": "Bağlan",
      "connect_aria": "{{what}} bağla",
      "checking": "Kontrol ediliyor…",
      "loadError": "Bağlantıların yüklenemedi.",
      "tryAgain": "Tekrar dene",
      "offline": "Çevrimdışısınız. Tekrar çevrimiçi olduğunuzda bağlanın.",
      "unavailable": "Takvimler ve görevler şu anda kullanılamıyor.",
      "disconnected": "{{provider}} bağlantısı kesildi.",
      "google": {
        "name": "Google",
        "sub": "Takvim ve Görevler",
        "what": "Google Takvim ve Görevler"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "Görevler ve projeler",
        "what": "Todoist"
      },
      "apple": {
        "name": "Takvim ve Hatırlatıcılar",
        "subNative": "Bu {{device}} üzerinde",
        "subSafari": "iPhone ve Mac için Rhemn uygulamasında"
      },
      "synced": "{{when}} senkronize edildi",
      "connectedSub": "Bağlı",
      "syncing": "Senkronize ediliyor…",
      "reconnectSub": "Senkronizasyona devam etmek için yeniden bağlan",
      "errorSub": "Son senkronizasyon tamamlanamadı",
      "pausedSub": "Duraklatıldı · Rhemn Pro sona erdi"
    },
    "explainer": {
      "google": {
        "title": "Google Takvim ve Görevleri bağla",
        "p1Lead": "Takvimin, salt okunur",
        "p1Body": "Rhemn etkinliklerini gününde gösterir ve ne zaman meşgul olduğunu görür. Onları saklamaz.",
        "p2Lead": "Google Görevler, iki yönlü",
        "p2Body": "Seçtiğin listeler senkronize kalır, böylece görevleri her yerden işaretleyebilirsin.",
        "p3Lead": "İstediğin zaman geri alınabilir",
        "p3Body": "İstediğin zaman bağlantıyı kes, burada ya da Google Hesabında.",
        "footnote": "Google, Rhemn'in tam olarak ne istediğini gösterecek."
      },
      "todoist": {
        "title": "Todoist'i bağla",
        "p1Lead": "Projelerin, iki yönlü",
        "p1Body": "Seçtiğin projeler senkronize kalır, böylece görevleri her yerden işaretleyebilirsin.",
        "p2Lead": "Nasıl eşleştiği",
        "p2Body": "Todoist öncelikleri Kritik, Yüksek, Orta ve Düşük olur. Bir seviyeden daha derin alt görevler, ana görevlerinin altında adımlar olarak gösterilir.",
        "p3Lead": "İstediğin zaman geri alınabilir",
        "p3Body": "İstediğin zaman bağlantıyı kes, burada ya da Todoist ayarlarında.",
        "cta": "Todoist'e devam et",
        "footnote": "Todoist senden onay isteyecek."
      },
      "skip": "Şimdi değil",
      "cancel": "İptal",
      "waiting": "{{provider}} bekleniyor…",
      "safariWaiting": "Yeni sekmede işlemi tamamla, sonra buraya dön.",
      "safariReopen": "Sekmeyi tekrar aç",
      "denied": "{{provider}} erişim vermedi, bu yüzden hiçbir şey bağlanmadı.",
      "error": "{{provider}}'a bağlanılamadı. Birazdan tekrar dene."
    },
    "detail": {
      "back_aria": "Takvimler ve görevlere dön",
      "syncNow": "Şimdi senkronize et",
      "intro": "Rhemn'in neyi senkronize edeceğini seç. Bunu istediğin zaman değiştirebilirsin.",
      "taskLists": "Görev listeleri",
      "projects": "Projeler",
      "reminders": "Hatırlatıcılar",
      "calendars": "Takvimler",
      "rhemnCalendarSub": "Namaz vakitlerin, meşgul sayılmaz",
      "loading": "Yükleniyor…",
      "loadError": "Listelerin yüklenemedi.",
      "emptyGoogle": "Google Görevler'de görev listesi yok.",
      "emptyTodoist": "Todoist'te proje yok.",
      "addError": "{{name}} eklenemedi. Tekrar dene.",
      "removed": "Rhemn'den kaldırıldı. Hâlâ {{provider}}'da duruyor.",
      "undo": "Geri al",
      "prayerTimes": "Namaz vakitlerini takvimine ekle",
      "prayerTimesSub": "Kimsenin üzerine plan yapmaması için önümüzdeki 7 gün boyunca beş vakit namazı Rhemn adlı bir takvime ekler.",
      "prayerTimesOn": "Açık. {{date}} tarihine kadar eklendi.",
      "prayerTimesWaiting": "Google bekleniyor…",
      "prayerTimesDenied": "Google izin vermedi. Hiçbir şey eklenmedi.",
      "prayerTimesRemoveAsk": "Rhemn'in namaz vakitleri takviminden kaldırılsın mı?",
      "prayerTimesKeep": "Kalsın",
      "prayerTimesRemove": "Kaldır",
      "meetingPrompts": "Toplantı hatırlatıcıları",
      "meetingPromptsSub": "Bağlantılı bir toplantı başlamak üzereyken not almayı öner.",
      "busyFootnote": "Günümü planla yalnızca ne zaman meşgul olduğunu görür, toplantılarının içeriğini asla görmez.",
      "todoistFootnote": "Todoist öncelikleri Kritik, Yüksek, Orta ve Düşük olur. Bir seviyeden daha derin alt görevler, ana görevlerinin altında adımlar olarak gösterilir.",
      "reauth": "{{provider}} Rhemn'in senkronize etmesine artık izin vermiyor. Bu, erişim kaldırıldığında veya şifren değiştiğinde olur.",
      "reconnect": "Yeniden bağlan",
      "paused": "Rhemn Pro sona erdiği için senkronizasyon duraklatıldı. Listelerin olduğu gibi kalır.",
      "calendarDenied": "Takvim erişimi kapalı.",
      "remindersDenied": "Hatırlatıcı erişimi kapalı.",
      "disconnect": "{{provider}} bağlantısını kes",
      "disconnectTitle": "{{provider}} bağlantısı kesilsin mi?",
      "disconnectBody": "{{provider}}'da hiçbir şey silinmez.",
      "disconnectRhemnCal": "Rhemn namaz vakitleri takvimin Google Takvim'den kaldırılacak.",
      "disconnectError": "{{provider}} bağlantısı kesilemedi. Birazdan tekrar dene.",
      "keepLists": "Listelerimi Rhemn'de tut",
      "keepListsSub": "Senkronizasyonları durur ve normal Rhemn listelerine dönüşürler.",
      "removeLists": "Rhemn'den kaldır",
      "removeListsSub": "Yalnızca Rhemn'deki kopyalar kaldırılır.",
      "disconnecting": "Bağlantı kesiliyor…",
      "appleStop": "Takvim ve Hatırlatıcılar'ı kullanmayı durdur",
      "appleStopTitle": "Takvim ve Hatırlatıcılar kullanımı durdurulsun mu?",
      "appleStopBody": "Rhemn etkinliklerini ve hatırlatıcılarını göstermeyi durdurur. Erişimini tamamen kaldırmak için Ayarlar'dan kapat.",
      "justNow": "az önce",
      "tasksScope": "Rhemn'in Google Tasks'ını görmesi için izin gerekiyor. Yeniden bağlan ve izin vermek için Görevler'i işaretle.",
      "calendarsLoadError": "Takvimlerin yüklenemedi.",
      "calendarsEmpty": "Bu hesapta takvim yok.",
      "calendarsScope": "Rhemn'in Google Takvim'ini görmek için izne ihtiyacı var. Yeniden bağlan ve izin vermek için Takvim'i işaretle.",
      "prayerTimesError": "Namaz vakitlerin eklenemedi. Biraz sonra tekrar dene.",
      "remindersEmpty": "Hatırlatıcılar'da liste yok.",
      "openSettings": "Ayarlar'ı aç",
      "appleStopCta": "Kullanmayı durdur"
    },
    "locked": {
      "body": "Toplantılarını namaz vakitlerinin içinde gör, Google Görevler'i Rhemn ile senkronize tut.",
      "googleName": "Google Takvim ve Görevler"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "cihaz"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, {{provider}} ile senkronize",
      "unlinkConfirm": "“{{name}}” Rhemn'den kaldırılsın mı? {{provider}}'da kalmaya devam eder.",
      "remove": "Kaldır",
      "offline": "Çevrimdışı · Değişiklikler tekrar çevrimiçi olduğunda {{provider}}'a senkronize edilecek.",
      "stillSyncing": "{{provider}} ile senkronizasyon hâlâ sürüyor…",
      "failed_one": "{{count}} değişiklik {{provider}}'a ulaşmadı.",
      "failed_other": "{{count}} değişiklik {{provider}}'a ulaşmadı.",
      "retry": "Tekrar dene",
      "needsReconnect": "{{provider}} yeniden bağlanmanı istiyor.",
      "paused": "Senkronizasyon duraklatıldı · Rhemn Pro sona erdi.",
      "upgrade": "Yükselt",
      "notSynced": "Senkronize edilmedi",
      "notSynced_aria": "{{provider}}'a senkronize edilmedi. Tekrar dene.",
      "remindersOff": "Rhemn, Hatırlatıcılar'a erişemiyor. Ayarlar'dan tekrar aç.",
      "dueToday": "Bugün",
      "dueTomorrow": "Yarın",
      "googleTasks": "Google Görevler"
    },
    "today": {
      "allDay": "Tüm gün",
      "more": "+{{count}}",
      "more_aria": "{{count}} tüm gün etkinliği daha göster",
      "less_aria": "Daha az tüm gün etkinliği göster",
      "events_aria": "Etkinlikler",
      "event_aria": "{{start}} - {{end}}, {{title}}",
      "allDayEvent_aria": "Tüm gün, {{title}}",
      "untitled": "Meşgul",
      "now": "Şimdi · {{end}} saatine kadar",
      "until": "{{end}} saatine kadar",
      "into": "· {{prayer}} vaktine uzanıyor",
      "loadError": "Takvimin yüklenemedi.",
      "needsReconnect": "Google Takvim yeniden bağlanmanı istiyor.",
      "scope": "Rhemn Google Takvim'ini göremiyor. Yeniden bağlan ve izin vermek için Takvim'i işaretle.",
      "appleOff": "Rhemn takvimini göremiyor. Ayarlar'dan yeniden aç."
    },
    "plan": {
      "mostlyMeetings": "Çoğunlukla toplantı · {{duration}} boş",
      "noFreeTime": "Boş zaman yok",
      "aroundMeetings_one": "{{count}} toplantıya göre planlandı.",
      "aroundMeetings_other": "{{count}} toplantıya göre planlandı.",
      "settledBusy": "Her şey zaten toplantılarının arasına sığıyor."
    },
    "meeting": {
      "group_aria": "Toplantı başlıyor",
      "now": "şimdi",
      "takeNotes": "Not al",
      "takeNotes_aria": "{{title}} için not al",
      "dismiss_aria": "Kapat",
      "announce": "{{title}} {{when}} başlıyor.",
      "announceNow": "{{title}} şimdi başlıyor.",
      "yourMeeting": "Toplantın"
    },
    "apple": {
      "primer": {
        "title": "Takvimini namazlarının yanında gör",
        "body": "Rhemn, etkinlikleri ve hatırlatıcıları gününe yerleştirmek için bu {{device}} üzerinden okur. Hepsi cihazında kalır. Günümü planla yalnızca meşgul olduğun saatleri kullanır.",
        "cta": "Devam",
        "skip": "Şimdi değil",
        "footnote": "{{device}} iki kez soracak, bir kez Takvim ve bir kez Hatırlatıcılar için. İkisini de Ayarlar'dan değiştirebilirsin."
      }
    }
  }
}
